// Option 4: Icon Mark + Text - Modern & Compact
export default function LogoOption4({ className = "", color = "#0D382A" }: { className?: string; color?: string }) {
  return (
    <svg
      viewBox="0 0 150 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* "No Doubles" text */}
      <text
        x="0"
        y="26"
        fill={color}
        fontFamily="'Brush Script MT', cursive"
        fontSize="24"
        fontStyle="italic"
      >
        No Doubles
      </text>
      
      {/* Small swoosh */}
      <path
        d="M 0 30 Q 24 28 48 29 T 96 30"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
      />
      
      {/* "GOLF CO" centered under No Doubles */}
      <text
        x="48"
        y="40"
        fill={color}
        fontFamily="system-ui, -apple-system, sans-serif"
        fontSize="8"
        fontWeight="600"
        letterSpacing="1.5"
        textAnchor="middle"
        opacity="0.7"
      >
        GOLF CO
      </text>
    </svg>
  );
}




